import React, { useEffect, useRef, useState } from "react";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useSelector } from "react-redux";
import services from "utils/services";
import dayjs, { Dayjs } from "dayjs";

import Select from "shared/Select/Select";
import { Shift } from "data/data";
// import { saveFilters } from "redux/reducers/auth";
import { avatarColors, MONTH_DISPLAY } from "contains/contants";

import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import customParseFormat from "dayjs/plugin/customParseFormat"; // ES 2015
import weekOfYear from "dayjs/plugin/weekOfYear";
import updateLocale from "dayjs/plugin/updateLocale";

import "dayjs/locale/fr";

import { CheckIcon, InformationCircleIcon } from "@heroicons/react/24/outline";
import { useAuth } from "provider/useAuth";
import ModalCongesRecup from "components/ModalCongesRecup";
import {
	BookmarkIcon,
	PencilIcon,
	UserGroupIcon,
	XMarkIcon,
} from "@heroicons/react/24/solid";
import Input from "shared/Input/Input";
import ModalAlert from "components/ModalAlert";
import ModalComment from "components/ModalComment";
import { Tooltip } from "react-tooltip";
dayjs.extend(isSameOrBefore);
dayjs.extend(customParseFormat);
dayjs.extend(weekOfYear);
dayjs.locale("fr");
dayjs.extend(updateLocale);

dayjs.updateLocale("fr", {
	weekStart: 1,
});
const formatter = new Intl.NumberFormat("fr-FR", {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
});

function Invoice() {
	const authContext = useAuth();
	const isAdmin = useRef(authContext.user.role === "ADMIN");
	const today = useRef(dayjs().startOf("month"));
	const currentDate = useRef(dayjs().startOf("month"));

	const [invoiceToEdit, setInvoiceToEdit] = useState<any>(null);
	const [lineToEdit, setLineToEdit] = useState<any>(null);
	const [editCommentDivers, setEditCommentDivers] = useState<any>(false);
	const [invoices, setInvoices] = useState<any>([]);
	const [selectedMonth, setSelectedMonth] = useState(99);
	const [selectedYear, setSelectedYear] = useState(today.current.year());
	const [yearList, setYearList] = useState<any>([]);
	const [monthList, setMonthList] = useState<any>([]);
	const [employees, setEmployees] = useState<any>([]);
	const [showAlert, setShowAlert] = useState(false);
	const [showModalComment, setShowModalComment] = useState(false);
	const [loading, setLoading] = useState(true);

	// useEffect(() => {}, []);
	useEffect(() => {
		const monthList = [
			{
				value: 99,
				label: "Tout l'année",
			},
		];
		const years = [];
		const currentDay = dayjs();
		const lastMonthToShow = currentDay.clone();

		for (let y = 2025; y <= currentDay.year(); y++) {
			years.push(y);
		}

		let firstMonth = currentDay.startOf("year");
		const firstMonthNum = firstMonth.get("month");
		const lastMonthNum =
			currentDay.year() == selectedYear ? lastMonthToShow.month() : 11;
		for (let y = firstMonthNum; y <= lastMonthNum; y++) {
			monthList.push({
				value: firstMonth.get("month"),
				label: firstMonth.format("MMMM"),
			});
			firstMonth = firstMonth.add(1, "month");
		}

		setYearList(years);
		setMonthList(monthList);
		onChangePeriod();

		currentDate.current = currentDate.current
			.year(selectedYear)
			.month(selectedMonth === 99 ? 0 : selectedMonth);
		getEmployees();
	}, [selectedMonth, selectedYear]);

	const getEmployees = () => {
		services.getUsers(
			{
				sort: 1,
				entryDate:
					selectedMonth === 99
						? currentDate.current.startOf("year").format("YYYY-MM-DD")
						: currentDate.current.startOf("month").format("YYYY-MM-DD"),
				exitDate:
					selectedMonth === 99
						? currentDate.current.endOf("year").format("YYYY-MM-DD")
						: currentDate.current.endOf("month").format("YYYY-MM-DD"),
			},
			(res) => {
				setEmployees(res.users);
			},
			(err) => {
				console.error(err);
			}
		);
	};

	const getInvoices = (month: number = 0, year: number) => {
		services.getInvoices(
			{
				month,
				year,
			},
			(success) => {
				console.log(success);
				setInvoices(success.invoices);
			},
			(error) => {
				console.error(error);
			}
		);
	};

	// useEffect(() => {
	// 	if (displayType == MONTH_DISPLAY.value) {
	// 		today.current = today.current.startOf("month");
	// 	} else {
	// 		today.current = dayjs();
	// 	}

	// 	onChangePeriod();
	// }, [displayType]);
	// useEffect(() => {
	// 	onChangePeriod();
	// }, [displayDate]);

	// useEffect(() => {
	// 	getPlanning(dateFrom.format("YYYY-MM-DD"), dateTo.format("YYYY-MM-DD"));
	// }, [dateFrom, dateTo]);

	const onChangePeriod = () => {
		let selectMonth = selectedMonth;
		// if (selectedMonth < 3 && selectedYear == 2025) {
		// 	setSelectedMonth(3);
		// 	selectMonth = 3;
		// }
		// today.current = today.current
		// 	.set("month", selectMonth)
		// 	.set("year", selectedYear);
		// let dateFrom = today.current.startOf("month");
		// let dateTo = today.current.endOf("month");

		// let tmpDate = dayjs(dateFrom, "DD/MM/YYYY");

		// const days: any = [];
		// while (tmpDate.isSameOrBefore(dateTo)) {
		// 	days.push({
		// 		label: tmpDate.format("dd").charAt(0) + " " + tmpDate.format("DD"),
		// 		isSunday: tmpDate.day() === 0,
		// 		isMonday: tmpDate.day() === 1,
		// 		week: tmpDate.week(),
		// 		date: tmpDate.format("YYYY-MM-DD"),
		// 	});
		// 	tmpDate = tmpDate.add(1, "day");
		// }

		// setDayList(days);
		getInvoices(selectedMonth, selectedYear);
	};

	const getContentTooltip = (line: any) => {
		return line.comment || "";
	};
	const editInvoice = (invoice: any) => {
		setInvoiceToEdit(invoice);
		invoice.lines.forEach((line: any) => {
			line.newInvoiceAmount = line.invoiceAmount || 0;
			line.newNetSalary = line.netSalary || 0;
		});
		invoice.newNbTickets = invoice.nbTickets;
		invoice.newDivers = invoice.divers;
		setInvoices([...invoices]);
	};

	const cancelEditInvoice = (invoice: any) => {
		setInvoiceToEdit(null);
		invoice.lines.forEach((line: any) => {
			delete line.newInvoiceAmount;
			delete line.newNetSalary;
			delete invoice.newNbTickets;
			delete invoice.newDivers;
		});
		setInvoices([...invoices]);
	};

	const saveEditInvoice = (invoice: any, status: string) => {
		setInvoiceToEdit(null);
		invoice.lines.forEach((line: any) => {
			line.invoiceAmount = line.newInvoiceAmount;
			line.netSalary = line.newNetSalary;
		});
		invoice.nbTickets = invoice.newNbTickets;
		invoice.divers = invoice.newDivers;
		setInvoices([...invoices]);
		updateInvoice(invoice);
	};

	const validateInvoice = () => {
		const invoice = invoices.find((inv: any) => inv._id == showAlert);
		invoice.status = "VALIDATED";
		setInvoices([...invoices]);
		setShowAlert(false);
		updateInvoice(invoice);
	};

	const updateInvoice = (invoice: any) => {
		services.saveInvoice(
			invoice,
			(success) => {
				console.log("saveInvoice success", success);
			},
			(error) => {
				console.error(error);
			}
		);
	};

	const renderInvoice = (invoice: any, index: number) => {
		return (
			<div
				key={index}
				className={`w-[100%] items-center flex flex-col flex-1 border-neutral-500 border-l-none border-t-none dark:border-slate-700 overflow-hidden z-0`}
			>
				<div className="flex items-center justify-center border-r-2 text-sm w-full border-b h-[30px]">
					<div>
						{dayjs(invoice.invoiceDate).format("MMMM")}{" "}
						{isAdmin.current &&
						!invoiceToEdit &&
						invoice.status == "PENDING" ? (
							<>
								<ButtonPrimary
									className="rounded-lg ml-1"
									sizeClass="py-1 px-1"
									onClick={() => editInvoice(invoice)}
								>
									<PencilIcon className="h-3 w-3" />
								</ButtonPrimary>
								<ButtonPrimary
									className="rounded-lg p-2 !bg-green-200 !text-black !border-success border-[1px] hover:!bg-green-300 ml-1"
									sizeClass="py-1 px-1"
									onClick={() => setShowAlert(invoice._id)}
								>
									<CheckIcon className="h-3 w-3 " />
								</ButtonPrimary>
							</>
						) : isAdmin.current && invoiceToEdit?._id === invoice._id ? (
							<>
								<ButtonPrimary
									className="rounded-lg p-2 !bg-red-200 !text-red-600 !border-danger border-[1px] hover:!bg-red-300 ml-1"
									sizeClass="py-1 px-1"
									onClick={() => cancelEditInvoice(invoice)}
								>
									<XMarkIcon className="h-3 w-3" />
								</ButtonPrimary>
								<ButtonPrimary
									className="rounded-lg p-2 !bg-slate-200 !text-black  border-[1px] hover:!bg-slate-300 ml-1"
									sizeClass="py-1 px-1"
									onClick={() => saveEditInvoice(invoice, "")}
								>
									<CheckIcon className="h-3 w-3 " />
								</ButtonPrimary>
							</>
						) : null}
					</div>
					<div className="flex gap-1 items-center justify-center w-[50px]">
						<UserGroupIcon className="h-5 w-5" /> {invoice.lines.length}
					</div>
				</div>
				{employees.map((employee: any, indexD: number) => {
					const empLineInvoice = invoice.lines.find(
						(line: any) => line.employee.id == employee._id
					);
					return (
						<div
							key={indexD}
							className={
								"flex flex-row w-full min-h-[60px] items-center border-r-2 px-1 py-1 " +
								(indexD < employees.length - 1 ? "border-b" : "border-b-2")
							}
						>
							{isAdmin.current && (
								<div className="text-[13px] font-semibold flex-1 border-r px-1 text-right">
									{invoiceToEdit?._id === invoice._id && empLineInvoice ? (
										<Input
											className="text-right border-neutral-400"
											sizeClass="h-9 px-4 py-2"
											rounded="rounded-lg"
											type="text"
											value={empLineInvoice.newNetSalary}
											onChange={({ target }) => {
												invoice.totalSalary =
													parseFloat(invoice.totalSalary) -
													parseFloat(empLineInvoice.newNetSalary || 0);

												empLineInvoice.newNetSalary = target.value;

												invoice.totalSalary =
													parseFloat(invoice.totalSalary) +
													parseFloat(empLineInvoice.newNetSalary || 0);

												setInvoices([...invoices]);
											}}
										></Input>
									) : empLineInvoice && empLineInvoice.netSalary ? (
										formatter.format(empLineInvoice.netSalary) + " MAD"
									) : (
										"-"
									)}
								</div>
							)}
							<div className="text-[13px] font-semibold flex-1 text-right px-1 ">
								{invoiceToEdit?._id === invoice._id && empLineInvoice ? (
									<Input
										className="text-right border-neutral-400"
										sizeClass="h-9 px-4 py-2"
										rounded="rounded-lg"
										type="text"
										value={empLineInvoice.newInvoiceAmount}
										onChange={({ target }) => {
											invoice.totalInvoice =
												parseFloat(invoice.totalInvoice) -
												parseFloat(empLineInvoice.newInvoiceAmount || 0);

											empLineInvoice.newInvoiceAmount = target.value;

											invoice.totalInvoice =
												parseFloat(invoice.totalInvoice) +
												parseFloat(empLineInvoice.newInvoiceAmount || 0);

											setInvoices([...invoices]);
										}}
									></Input>
								) : empLineInvoice && empLineInvoice.invoiceAmount ? (
									formatter.format(empLineInvoice.invoiceAmount) + " €"
								) : (
									"-"
								)}
							</div>

							<div
								className={
									"text-[13px] font-semibold w-[30px] text-center " +
									(invoiceToEdit?._id === invoice._id ? " cursor-pointer" : "")
								}
							>
								{empLineInvoice &&
								(invoiceToEdit?._id === invoice._id ||
									empLineInvoice.comment) ? (
									<InformationCircleIcon
										className="h-5 w-5"
										onClick={() => {
											if (invoiceToEdit?._id === invoice._id) {
												setLineToEdit(empLineInvoice);
												setShowModalComment(true);
											}
										}}
										data-tooltip-id="tooltip-comment-line"
										data-tooltip-html={empLineInvoice.comment || ""}
									/>
								) : null}
							</div>
						</div>
					);
				})}
				<div className="flex flex-row w-full h-[50px] items-center border-r-2 border-b-2">
					<div className="text-[13px] font-semibold flex-1 text-right px-2 ">
						{invoiceToEdit?._id === invoice._id ? (
							<Input
								className="text-right border-neutral-400"
								sizeClass="h-9 px-4 py-2"
								rounded="rounded-lg"
								type="text"
								value={invoice.newDivers}
								onChange={({ target }) => {
									invoice.totalInvoice =
										parseFloat(invoice.totalInvoice) -
										parseFloat(invoice.newDivers || 0);

									invoice.newDivers = target.value;

									invoice.totalInvoice = (
										parseFloat(invoice.totalInvoice) +
										parseFloat(invoice.newDivers || 0)
									).toFixed(2);

									setInvoices([...invoices]);
								}}
							></Input>
						) : (
							formatter.format(invoice.divers || 0) + " €"
						)}
					</div>
					<div
						className={
							"text-[13px] font-semibold w-[30px] text-center " +
							(invoiceToEdit?._id === invoice._id ? " cursor-pointer" : "")
						}
					>
						{invoiceToEdit?._id === invoice._id || invoice.commentDivers ? (
							<InformationCircleIcon
								className="h-5 w-5"
								onClick={() => {
									if (invoiceToEdit?._id === invoice._id) {
										setEditCommentDivers(true);
										setShowModalComment(true);
									}
								}}
								data-tooltip-id="tooltip-comment-line"
								data-tooltip-html={invoice.commentDivers || ""}
							/>
						) : null}
					</div>
				</div>
				<div className="flex flex-row w-full h-[50px] items-center border-r-2 border-b-2 bg-secondary-100">
					<div className="text-[13px] font-semibold flex-1 text-right px-2 ">
						{invoiceToEdit?._id === invoice._id ? (
							<Input
								className="text-right border-neutral-400"
								sizeClass="h-9 px-4 py-2"
								rounded="rounded-lg"
								type="text"
								value={invoice.newNbTickets}
								onChange={({ target }) => {
									invoice.newNbTickets = target.value;
									setInvoices([...invoices]);
								}}
							></Input>
						) : (
							invoice.nbTickets || 0
						)}
					</div>
				</div>
				<div className="flex flex-row w-full h-[50px] items-center border-r-2 bg-slate-200">
					{isAdmin.current && (
						<div className="text-sm font-semibold flex-1 border-r p-2 text-right">
							{formatter.format(invoice.totalSalary) + " MAD"}
						</div>
					)}
					<div className="text-sm font-semibold flex-1 text-right px-2 ">
						{formatter.format(invoice.totalInvoice) + " €"}
					</div>
				</div>
			</div>
		);
	};

	const renderEmployees = () => {
		return (
			<div
				className={`w-[100%] items-center flex flex-col flex-1  border-neutral-500 border-l-none border-t-none dark:border-slate-700 overflow-hidden z-[20] sticky left-0 bg-white`}
			>
				<div className=" pl-2 flex gap-2 items-center border-r-2 w-full border-b h-[30px]">
					<UserGroupIcon className="h-5 w-5" /> {employees.length}
				</div>
				{employees.map((employee: any, indexD: number) => {
					return (
						<div
							key={indexD}
							className={
								"flex flex-col w-full h-[60px] items-start justify-center text-sm font-semibold border-r-2 pl-2 py-1 " +
								(indexD < employees.length - 1 ? "border-b" : "border-b-2")
							}
						>
							<div>
								{employee.lastName} {employee.firstName}{" "}
							</div>
							<div className="text-xs font-normal">
								E: {dayjs(employee.entryDate).format("DD/MM/YYYY")} <br />
								{!!employee.exitDate &&
									"S: " + dayjs(employee.exitDate).format("DD/MM/YYYY")}
							</div>
						</div>
					);
				})}

				<div
					className={
						"flex flex-row w-full h-[50px] items-center text-sm font-semibold border-b-2 border-r-2 pl-2 text-center"
					}
				>
					Charges diverses{" "}
				</div>
				<div
					className={
						"flex flex-row w-full h-[50px] items-center text-sm font-semibold border-b-2 border-r-2 pl-2 text-center bg-secondary-100"
					}
				>
					Nombre fichiers traités
				</div>
				<div
					className={
						"flex flex-row w-full h-[50px] items-center font-semibold border-r-2 pl-2 text-center bg-slate-200"
					}
				>
					Total
				</div>
			</div>
		);
	};
	const getTotalInvoice = () => {
		return (invoices || []).reduce(
			(acc: number, curr: any) => acc + parseFloat(curr.totalInvoice),
			0
		);
	};

	return (
		<div className="nc-Invoice relative overflow-hidden">
			{/* SECTION HERO */}
			{/* <SectionHero2 /> */}

			<div className="relative my-8 px-14">
				<div>
					<h2 className="text-2xl md:text-3xl font-semibold">Facturation</h2>
					<div className="flex flex-row gap-3 mt-2">
						<Select
							className="!w-[150px] rounded-lg border-slate-500"
							onChange={({ target }) => {
								setSelectedMonth(parseInt(target.value));
							}}
							value={selectedMonth}
						>
							{monthList.map((m: any, i: number) => (
								<option value={m.value}>{m.label}</option>
							))}
						</Select>
						{yearList.length > 0 && (
							<Select
								className="!w-[100px] rounded-lg border-slate-500"
								onChange={({ target }) => {
									setSelectedYear(parseInt(target.value));
								}}
								value={selectedYear}
							>
								<option></option>
								{yearList.map((y: number, i: number) => {
									return (
										<option value={y} key={i}>
											{y}
										</option>
									);
								})}
							</Select>
						)}
						<ButtonPrimary
							className="rounded-lg"
							disabled={
								(!selectedMonth && selectedMonth !== 0) ||
								(!selectedYear && selectedYear !== 0)
							}
							onClick={() => onChangePeriod()}
						>
							<CheckIcon className="h-5 w-5" />
						</ButtonPrimary>
					</div>
				</div>
				<div className=" relative mb-3">
					<BackgroundSection className="bg-neutral-50/80 dark:bg-black/20" />
					<div className="flex mt-2 justify-end items-start gap-2"></div>
					<div className="flex flex-col py-2 items-center relative">
						<div className="w-[100%]">
							<div className="flex flex-col gap-3 items-center">
								<div className="max-w-[100%] min-w-[420px] border-2 border-slate-500 rounded-lg min-h-80">
									<div className="flex flex-row items-center justify-between gap-3 py-3 px-3 bg-white rounded-t-lg border-dashed border-slate-500 border-b-4 rounded-b-none">
										<span className="font-semibold text-lg">
											{selectedMonth !== 99
												? monthList.find((m: any) => m.value == selectedMonth)
														?.label
												: ""}{" "}
											{selectedYear}
										</span>
										<span className="font-semibold text-lg">
											Total Facturation : {formatter.format(getTotalInvoice())}{" "}
											€
										</span>
									</div>

									<div
										className={`grid grid-rows-${
											employees?.length + 2
										} overflow-x-scroll`}
										style={{
											gridTemplateColumns: `repeat(${
												invoices.length + 1
											} , ${"250px"})`,

											// gridTemplateColumns: `repeat(${
											// 	selectedMonth === 99 ? monthList.length : 2
											// } , 210px)`,
										}}
									>
										{renderEmployees()}

										{!!invoices &&
											invoices.length > 0 &&
											invoices.map((invoice: any, index: number) =>
												renderInvoice(invoice, index)
											)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{!!showAlert &&
				!!authContext.user &&
				authContext.user.role === "ADMIN" && (
					<ModalAlert
						onCloseModal={() => setShowAlert(false)}
						onConfirm={() => validateInvoice()}
						confirmText="Oui"
						closeText="Non"
						title="VALIDER LA FACTURE"
						text="Êtes vous sûr de valider la facture ?"
						show={showAlert}
					/>
				)}
			{!!showModalComment && (
				<ModalComment
					onCloseModal={() => setShowModalComment(false)}
					onConfirm={(newComment) => {
						setShowModalComment(false);
						if (editCommentDivers) {
							invoiceToEdit.commentDivers = newComment;
							setEditCommentDivers(false);
						} else {
							setLineToEdit(null);
							lineToEdit.comment = newComment;
						}
						setInvoices([...invoices]);
					}}
					comment={
						editCommentDivers ? invoiceToEdit.commentDivers : lineToEdit.comment
					}
					show={showModalComment}
				/>
			)}
			<Tooltip id="tooltip-comment-line" place="bottom" />
		</div>
	);
}

export default Invoice;
